export { SkeletonLoaderWrapper, SkeletonLoader } from './src/skeleton-loader';
export type { SkeletonLoaderProps } from './src/skeleton-loader';
